module.exports = __webpack_public_path__ + "img/list2.3f6fdaee.png";